import { FC } from 'react';
import { Box, Divider, Flex, Image, Stack } from '@chakra-ui/react';

import { getCardRequestAssetSrc } from 'common/paymentCards/utils';
import Heading from 'components/_core/Heading';
import Text from 'components/_core/Text';
import { formatDate } from 'helpers/date';

import { Request } from '../../../../hooks/useRequests';
import locales from './locales';

interface ArchivedRequestSummaryProps {
  request: Request;
}

const ArchivedRequestSummary: FC<ArchivedRequestSummaryProps> = ({
  request,
}) => {
  const isPhysicalPaymentCardRequest =
    request.__typename === 'PhysicalPaymentCardOrderRequest';

  return (
    <Box>
      <Box paddingBottom="space-16">
        <Image
          alt=""
          role="presentation"
          src={getCardRequestAssetSrc(request)}
          width="3.375rem"
        />
      </Box>

      <Box paddingBottom="space-8">
        <Heading>
          {isPhysicalPaymentCardRequest
            ? locales.titles.physicalCard
            : locales.titles.virtualCard}
        </Heading>
      </Box>

      <Stack divider={<Divider />} spacing="space-0">
        {request.requester ? (
          <Flex justifyContent="space-between" paddingY="space-16">
            <Text>{locales.requester}</Text>
            <Text variant="primary">
              {request.requester.firstName} {request.requester.lastName}
            </Text>
          </Flex>
        ) : null}

        <Flex justifyContent="space-between" paddingY="space-16">
          <Text>{locales.status}</Text>
          <Text variant="primary">{locales.statusLabel[request.status]}</Text>
        </Flex>

        <Flex justifyContent="space-between" paddingY="space-16">
          <Text>{locales.dateLabel[request.status]}</Text>
          <Text variant="primary">
            {formatDate(
              +new Date(request.reviewedAt ?? request.createdAt),
              'P',
            )}
          </Text>
        </Flex>
      </Stack>
    </Box>
  );
};

export default ArchivedRequestSummary;
